import { z } from 'zod';
/**
 * Social stats contract for follower/following statistics
 * Requires authentication
 */

export const SocialStatsResponseSchema = z.object({
  totalFollowers: z.number(),
  totalFollowing: z.number(),
  mutualConnections: z.number(),
  lastSocialSyncAt: z.string().nullable(),
  socialSyncInProgress: z.boolean(),
});

export type SocialStatsResponse = z.infer<typeof SocialStatsResponseSchema>;
